import L from 'leaflet';

// Vector markers do not depend on Leaflet's default PNG asset URLs.
export function mapPointToLayer(feature, latlng, opacity = 1) {
  const marker = L.circleMarker(latlng, {
    radius: 6, color: '#ffffff', weight: 2,
    fillColor: '#22d3ee', fillOpacity: opacity, opacity,
  });
  const name = feature?.properties?.name;
  if (name) {
    const label = document.createElement('span');
    label.textContent = String(name);
    marker.bindTooltip(label);
  }
  return marker;
}
